<div class="content dark">
	<div *ngIf="rotor" class="row">
		<label class="col-md-2 col-form-label">Operation:</label>
		<div *ngIf="!multiOps" class="col-md-4">
			<select *ngIf="operations !== undefined" class="form-control form-control-sm op-list" [(ngModel)]="operation" (ngModelChange)="refreshRegimeCounts()"
				title="Only showing {{ operations && operations.length >= 800 ? 'latest 800 ' : '' }}operations with vibe data for rotor '{{rotor.rotorid}}'">
				<option *ngFor="let operation of operations" [ngValue]="operation" [ngClass]="{ 'has-ex': operation.exceedance_count > 0 }">
					{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}{{operation.rotor_turn_time |
					runtime : " Rotor: "}}{{operation.flight_time | runtime : " Flight: "}}{{operation.exceedance_count > 0 ? "
					Ex: " + operation.exceedance_count : ""}}
				</option>
			</select>
			<select *ngIf="operations === undefined" class="form-control form-control-sm" disabled>
				<option>Loading RTB operations...</option>
			</select>
		</div>
		<div *ngIf="multiOps" class="col-md-4">
			<select *ngIf="operations !== undefined" class="form-control form-control-sm" [(ngModel)]="multiOperation" (ngModelChange)="refreshRegimeCounts()"
				title="Only showing {{ operations && operations.length >= 800 ? 'latest 800 ' : '' }}operations with vibe data for rotor '{{rotor.rotorid}}'" multiple>
				<option *ngFor="let operation of operations" [ngValue]="operation">
					{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</option>
			</select>
			<select *ngIf="operations === undefined" class="form-control form-control-sm" disabled multiple>
				<option>Loading RTB operations...</option>
			</select>
		</div>
		<div class="col-md-6">
			<label class="col-form-label">
				<input [(ngModel)]="multiOps" type="checkbox" (ngModelChange)="refreshRegimeCounts()">
				Multiple operations
			</label>
			<p *ngIf="multiOps">Ctrl+click to select multiple operations, 5 maximum</p>
		</div>
	</div>
	<div *ngIf="regimeCounts !== undefined && regimeCounts.length === 0" style="padding: 50px;">
		No balance data is available for the selected operation
	</div>
	<div *ngIf="regimeCounts !== undefined && regimeCounts.length > 0" class="row">
		<div class="col-lg-4">
			<div class="item-panel">
				<div class="heading">Regimes</div>
				<div class="content">
					<table class="table regimes">
						<tr>
							<th># Acq</th>
							<th>Regime</th>
							<th>Evaluate</th>
						</tr>
						<tr *ngFor="let regime of regimeCounts">
							<td>{{regime.count}}</td>
							<td>{{regime.name}}</td>
							<td class="center">
								<input type="checkbox" [(ngModel)]="regime.evaluate" (ngModelChange)="regimesChange()">
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div *ngIf="rotor.balancedata && rotor.balancedata.numblades >= 4 && !rotor.balancedata.oneperrev" class="row">
				<div class="col-sm-4">
					Shaft Order
				</div>
				<div class="col-sm-8">
					<div class="form-check form-check-inline">
						<label class="form-check-label">
							<input [(ngModel)]="shaftOrder" class="form-check-input" type="radio" [value]="1" (ngModelChange)="updatePlot()"> 1/rev
						</label>
					</div>
					<div class="form-check form-check-inline">
						<label class="form-check-label">
							<input [(ngModel)]="shaftOrder" class="form-check-input" type="radio" [value]="2" (ngModelChange)="updatePlot()"> 2/rev
						</label>
					</div>
				</div>
				<div class="col-sm-4">
					1/rev Only
				</div>
				<div class="col-sm-8">
					<div class="form-check form-check-inline">
						<label class="form-check-label">
							<input type="checkbox" [(ngModel)]="onePerRevOnly" (ngModelChange)="updatePlot()">
						</label>
					</div>
				</div>
			</div>
			<div *ngIf="selectedRegimes && selectedRegimes.length" class="item-panel">
				<div class="heading">Adjustments</div>
				<div class="content">
					<table class="table adjustments">
						<ng-container *ngFor="let adjdef of rotor.adjdef; let i = index">
							<!-- Display heading for every "display group" -->
							<tr *ngIf="i === 0 || rotor.adjdef[i].displaygroup !== rotor.adjdef[i-1].displaygroup">
								<th></th>
								<th *ngFor="let blade of FilterBlades(rotor.adjdef[i].displaygroup)">{{blade.name}}</th>
							</tr>
							<tr>
								<th>
									<a [hidden]="!alternates || !alternates[i].length" (click)="adjDetail[i] = !adjDetail[i]" href="javascript:void(0)" class="nowrap">{{ adjdef.name }} &#9662;</a>
									<span [hidden]="alternates && alternates[i].length">{{ adjdef.name }}:</span>
								</th>
								<td *ngFor="let blade of FilterBlades(rotor.adjdef[i].displaygroup); let j = index">
									<input *ngIf="adjustments" [(ngModel)]="adjustments[i][j]" (keyup.enter)="ManualAdjustment()" type="number" class="adj-entry">
								</td>
								<th class="adjust-check">
									<input [(ngModel)]="adjustmentSelect[i]" class="form-check-input" type="checkbox" (ngModelChange)="updatePlot()">
								</th>
							</tr>
							<ng-container *ngIf="alternates">
								<tr *ngFor="let alt of alternates[i]; let altIdx = index" (click)="SetAdjustment(i, altIdx)" [hidden]="!adjDetail[i]" class="alt-row">
									<th></th>
									<td *ngFor="let blade of FilterBlades(rotor.adjdef[i].displaygroup); let j = index">
										<div *ngIf="adjustments">{{alt[j] | number : "1.0-1"}}</div>
									</td>
									<th></th>
								</tr>
							</ng-container>
							<tr class="divider">
								<th></th>
							</tr>
						</ng-container>
					</table>
					<button [disabled]="this.api.user.role === 'readonly'" (click)="RecordAdjustment()" class="btn btn-primary btn-sm form-control">Record adjustment</button>
				</div>
			</div>
		</div>
		<div *ngIf="vshafts && vshafts.length" class="col-lg-8 mt-3">
			<ul ngbNav #nav="ngbNav" [activeId]="defaultVshaft" class="nav-tabs light">
				<li *ngFor="let vshaft of vshafts" ngbNavItem [ngbNavItem]="vshaft.name">
					<a ngbNavLink>{{ vshaft.name }}</a>
					<ng-template ngbNavContent>
						<div class="comp-plot">
							<app-dvs-chart [error]="errormessage" [options]="vshaft.plotOptions" [light]="true" [height]="'600px'"></app-dvs-chart>
							<div *ngIf="vshaft.plotOptions" class="legend">
								<span class="legend-item">
									<span class="swatch" style="background-color: #027A85"></span> Averages
								</span>
								<span class="legend-item">
									<span class="swatch" style="background-color: #DBCD00"></span> Predictions
								</span>
							</div>
						</div>
						<div *ngIf="trackOptions" class="item-panel">
							<div class="heading">Blade track</div>
							<div class="content">
								<app-dvs-chart [options]="trackOptions" [light]="true" [height]="'400px'"></app-dvs-chart>
								<div *ngIf="trackOptions" class="legend">
									<span class="legend-item">
										<span class="swatch" style="background-color: #027A85"></span> Averages
									</span>
									<span class="legend-item">
										<span class="swatch" style="background-color: #DBCD00"></span> Predictions
									</span>
								</div>
							</div>
						</div>
						<div>
							<button (click)="DownloadData(vshaft)" title="Download a text output of the RTB average and predictions" class="btn btn-primary btn-sm form-control mt-3">Download
								CSV</button>
						</div>
					</ng-template>
				</li>
			</ul>
			<div [ngbNavOutlet]="nav"></div>
		</div>
	</div>
	<div *ngIf="operations && operations.length === 0" class="pt-4 pb-5">
		No operations with vibe data are available
	</div>
	<div *ngIf="operations && operations.length > 0 && regimeCounts === undefined" class="text-center pt-3 pb-3">
		<div class="logo-spin light"></div>
		Loading operation data...
	</div>
</div>